var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconUnlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4545 1.17395H14.9091C15.4463 1.17395 15.9783 1.30328 16.4746 1.55455C16.9709 1.80583 17.4219 2.17412 17.8018 2.63842C18.1817 3.10271 18.483 3.65391 18.6886 4.26053C18.8942 4.86716 19 5.51734 19 6.17395C19 6.83056 18.8942 7.48074 18.6886 8.08737C18.483 8.69399 18.1817 9.24519 17.8018 9.70948C17.4219 10.1738 16.9709 10.5421 16.4746 10.7933C15.9783 11.0446 15.4463 11.1739 14.9091 11.1739H12.4545M7.54545 11.1739H5.09091C4.55368 11.1739 4.02172 11.0446 3.52539 10.7933C3.02905 10.5421 2.57808 10.1738 2.1982 9.70948C1.43101 8.7718 1 7.50003 1 6.17395C1 4.84787 1.43101 3.5761 2.1982 2.63842C2.96539 1.70073 4.00593 1.17395 5.09091 1.17395H7.54545M6.72727 6.17395H13.2727",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconUnlink);
export default __webpack_public_path__ + "static/media/button-icon-unlink.f4a2a876ca4753eaec4375ab653e52a0.svg";
export { ForwardRef as ReactComponent };